import React from 'react';
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css'; // Allows for server-side rendering.
import './nav-bar.css';

const NavBarCommon = (props) => {
  const { solapas } = props;
  const options = {
    items: 10,
    // navSpeed: 200,
    dots: false,
    // rewind: true,
    rtl: false,
    // autoplay: false,
    responsive: {
      0: {
        navText: ['', ''],
        nav: true,
        stagePadding: 30,
        items: 3,
      },
      480: {
        navText: ['', ''],
        nav: true,
        stagePadding: 40,
        items: 5,
      },
      768: {
        navText: ['›', '›'],
        nav: true,
        stagePadding: solapas.length > 10 ? 50 : 0,
        items: 10,
      },
    },
  };

  const events = {};
  const mobile = window.innerWidth <= 768;

  const classIfHasLessThanTen = (solapas.length <= 10)
    ? 'has-min-items'
    : '' ;

  return (
    <nav>
      <div className={`container ${mobile ? '' : classIfHasLessThanTen}`}>
        {solapas.length > 1 ? (
          <OwlCarousel id='nav-c' options={options} events={events}>
            {solapas}
          </OwlCarousel>
        ) : null}
      </div>
    </nav>
  );
};

export default NavBarCommon;
